// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1041":"780b4a79","2959":"66f0f0cd","3963":"780b4a79","6408":"d13ab3c9","6718":"e4fc6c76","9534":"9524a689"}[chunkId] + ".chunk.css";
};